import type { Fontenehus } from "../types/Fontenehus";
import type { User } from "../types/User";

export const useCommonFunctions = (
  user?: User | null,
  selectedFontenehus?: Fontenehus | null,
) => {
  const canAddSuggestion =
    !user?.roles?.some((r) => ["Guest"].includes(r)) &&
    user?.fontenehusId === selectedFontenehus?.id;

  const canLike =
    !user?.roles?.some((r) => ["Guest"].includes(r)) &&
    user?.fontenehusId === selectedFontenehus?.id;

  return {
    canAddSuggestion,
    canLike,
  };
};
